import { createSelector } from '@ngrx/store';
import { User } from 'src/app/models/user.model';
import * as fromReducer from '../reducers/contacts.reducer';
import { getCurrentUser } from './users.selector';

export const getContactsEntities = createSelector(
  fromReducer.getContactsFeatureState,
  fromReducer.getContactsEntities,
);

export const getContacts = createSelector(getContactsEntities, (entities) =>
  Object.keys(entities).map((id) => entities[id]),
);

export const getUsersWithOktaId = createSelector(
  getContacts,
  getCurrentUser,
  (contacts: User[], currentUser: User): User[] =>
    contacts.filter(
      (contact) =>
        contact?.Portal_Role__c !== null &&
        contact?.OktaUsername__c !== null &&
        contact.Id !== currentUser.Id,
    ),
);

export const getContactsLoaded = createSelector(
  fromReducer.getContactsFeatureState,
  fromReducer.getContactsLoaded,
);
export const getContactsLoading = createSelector(
  fromReducer.getContactsFeatureState,
  fromReducer.getContactsLoading,
);
export const getContactsError = createSelector(
  fromReducer.getContactsFeatureState,
  fromReducer.getContactsError,
);
